import { Component, OnInit } from '@angular/core';
import { RouterLinkInfoService } from 'src/app/services/router-link-info.service';

@Component({
  selector: 'app-afood-logger-master',
  templateUrl: './afood-logger-master.component.html',
  styleUrls: ['./afood-logger-master.component.css']
})
export class AFoodLoggerMasterComponent implements OnInit {

  constructor(private routerinfoservice: RouterLinkInfoService) { }

  ngOnInit() {
  }
  onActivate(componentRef) {
    try {
      var currentUrl = window.location.pathname;
      // var me =  componentRef.getPageName();
      // this.CData =me;
      $('#breadItem').text(this.routerinfoservice.getPageName(currentUrl));
    }
    catch (ex) {
      console.log('Not set');
    }
  }
}
